import React from 'react';
import style from './style.module.scss';
import {IProductShort} from 'modules/products/types';
import {useIsPrive} from 'core/hooks/useIsPrive';
import {ProductCardActions} from 'modules/product-card-actions/components/ProductCardActions';
import NextLink from 'components/CustomRoutingLink';
import Picture from 'components/Picture';
import {getMediaSrc} from 'core/helpers/media';
import {Typography} from 'components/Typography';
import Link from 'components/Link';
import {formatPrice} from 'core/helpers';
import cs from 'classnames';

type TProductCardProps = {product: IProductShort; withPadding?: boolean};

// eslint-disable-next-line complexity
export const ProductCard = ({product, withPadding}: TProductCardProps) => {
    const {
        price: {
            base: {price: basePrice},
            discount: {discountValue, price: discountPrice},
            specPrice,
            isSpecPrice,
        },
        media: {imagePreview},
        id,
        title,
        url,
        canBuy,
        canReserve,
        description,
    } = product;

    const isDiscountPrice = discountPrice !== basePrice || isSpecPrice;
    const priceAfterDiscount = isSpecPrice ? specPrice : discountPrice;
    const isPrive = useIsPrive();
    const outOfStock = isPrive ? !canBuy : !canBuy && !canReserve;

    return (
        <div className={cs(style.main, {[style.noPadding]: !withPadding})}>
            <div className={style.productCardWrapper}>
                {imagePreview && (
                    <NextLink href={url} legacyBehavior={true} passHref={true}>
                        <a className={style.imageContainer}>
                            <Picture alt={title || ''} sources={{}} src={getMediaSrc(imagePreview)} />
                        </a>
                    </NextLink>
                )}
                <div className={style.containerWrapper}>
                    <Link href={url} legacyBehavior={true} theme={'black'}>
                        <Typography className={style.title} element={'div'} variant={'snippet-title-16-r'}>
                            {title}
                        </Typography>
                    </Link>
                    <div className={style.info}>
                        <Typography className={style.text} color={'gray60'} element={'div'} variant={'label-12-r'}>
                            {description}
                        </Typography>
                        <Typography
                            className={style.articleContainer}
                            color={'gray60'}
                            element={'div'}
                            variant={'label-12-r'}
                        >
                            Артикул: {id}
                        </Typography>
                        {outOfStock && (
                            <Typography
                                className={style.text}
                                color={'black100'}
                                element={'div'}
                                variants={{
                                    DT: 'label-14-r',
                                    TB: 'label-14-r',
                                    MB: 'label-12-r',
                                }}
                            >
                                Этот товар закончился
                            </Typography>
                        )}
                    </div>
                    <div className={style.priceContainer}>
                        <div className={style.oldPriceContainer}>
                            {isDiscountPrice && !outOfStock && (
                                <>
                                    <Typography
                                        className={style.oldPrice}
                                        color={'primary60'}
                                        variant={'label-12-r-lt'}
                                    >
                                        {basePrice}&nbsp;₽
                                    </Typography>
                                    {!isSpecPrice && <Typography variant={'label-12-r'}>-{discountValue}%</Typography>}
                                </>
                            )}
                            <Typography
                                className={style.price}
                                element={'div'}
                                color={isDiscountPrice && !outOfStock ? 'primary100' : undefined}
                                variants={{DT: 'price-18-b', TB: 'body-18-m', MB: 'price-20-b'}}
                            >
                                {isDiscountPrice && !outOfStock
                                    ? formatPrice(String(priceAfterDiscount))
                                    : formatPrice(String(basePrice))}
                                {'\u00A0₽'}
                            </Typography>
                        </div>
                        <div className={style.productActionsWrapper}>
                            <ProductCardActions variant={'similar'} className={style.productActions} {...product} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
